import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';


import { ListDealersPage } from './list-dealers.page';
import { TranslateModule } from '@ngx-translate/core';
import { DealerMapPageModule } from '../../shared/dealer-map/dealer-map.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    DealerMapPageModule,
    TranslateModule
  ],
  declarations: [ListDealersPage]
})
export class ListDealersPageModule {}
